module.exports = "https://r.nearpod.com/assets/media/image/back-b2c1dce84419bce22df8b827e22c8627.svg";